import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Contacto = () => {
    const [acfData, setAcfData] = useState(null); // Estado para almacenar los datos del ACF
    const [fondoUrl, setFondoUrl] = useState(''); // Estado para almacenar la URL del fondo
    const [video, setLinkVideo] = useState(''); // Estado para almacenar la URL del video
    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        email: '',
        empresa: '',
        telefono: '',
        industria: ''
    });

    const [status, setStatus] = useState('');

    // Manejar cambios en el formulario
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // Manejar el envío del formulario
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('https://interprika.com/cms/wp-json/custom/v1/send-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                setStatus('Correo enviado con éxito!');
                setFormData({ nombre: '', apellido: '', email: '', empresa: '', telefono: '', industria: '' });
            } else {
                setStatus('Error al enviar el correo.');
            }
        } catch (error) {
            console.error('Error:', error);
            setStatus('Error al conectar con el servidor.');
        }
    };

    useEffect(() => {

        // Fetch data from the API
        const fetchData = async () => {
            try {
                const response = await fetch('https://interprika.com/cms/wp-json/wp/v2/pages/185');
                const data = await response.json();

                // Guarda los datos del ACF en el estado
                setAcfData(data.acf);

                // Si existe el ID del fondo, hacemos un fetch para obtener la URL de la imagen
                if (data.acf?.fondo) {
                    const imageResponse = await fetch(`https://interprika.com/cms/wp-json/wp/v2/media/${data.acf.fondo}`);
                    const imageData = await imageResponse.json();
                    setFondoUrl(imageData.source_url); // Guarda la URL del fondo en el estado
                }

                // Si existe el ID del fondo, hacemos un fetch para obtener la URL de la imagen
                if (data.acf?.fondo) {
                    const videoResponse = await fetch(`https://interprika.com/cms/wp-json/wp/v2/media/${data.acf.video}`);
                    const videoData = await videoResponse.json();
                    setLinkVideo(videoData.source_url); // Guarda la URL del fondo en el estado
                }

                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <div className='w-full h-full bg-black fixed top-0 z-[999999999] flex flex-col justify-center items-center'>
                <img className='w-[300px] max-md:w-[150px] h-[44px] object-contain' src='./images/logo.png' alt="" />
            </div>
        );
    }

    return (
        <div>
            {/* Header Section */}
            <div className='bg-[#000] overflow-hidden relative'>
                {/* Imagen de fondo del header */}
                {fondoUrl && (
                    <img
                        className='w-full max-md:h-[300px] object-fill md:object-contain'
                        src={fondoUrl}
                        alt="Header Background"
                    />
                )}
                
                {/* Contenido del header */}
                <div className='flex flex-col justify-center items-center w-full h-full top-[-50px] absolute max-md:pt-12'>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        variants={{
                            hidden: { opacity: 0, x: -200 },
                            visible: { opacity: 1, x: 0 },
                        }}
                        transition={{ duration: 0.5 }}
                        className='max-w-full w-[800px] mx-auto'
                    >
                        <div className='max-md:pl-20 max-md:pr-10 text-white text-[22px] md:text-[48px] leading-[28px] md:leading-[48px] pb-2 uppercase max-w-full' dangerouslySetInnerHTML={{ __html: acfData?.titulo }}>
                        </div>
                    </motion.div>
                </div>

                <div className='mt-[-135px] md:mt-[-100px]'>
                    <div className='clip-diagonal-orange'></div>
                    <div className='clip-diagonal-white'></div>
                </div>
            </div>

            {/* Form Section */}
            <div className="md:pt-10 pb-16 overflow-hidden">
                <div className="w-[1280px] 2xl:w-[1440px] max-w-full px-[30px] lg:px-[100px] mx-auto pt-12">
                    <div className="flex flex-col lg:flex-row justify-between items-center">
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            variants={{
                                hidden: { opacity: 0, x: -200 },
                                visible: { opacity: 1, x: 0 },
                            }}
                            transition={{ duration: 0.5 }}
                            className='w-full lg:w-1/2 lg:pr-[30px]'
                        >
                            <h3 className="text-2xl font-medium mb-4 uppercase">
                                conoce nuestras<br />
                                <span className="text-[#F89D38] font-bold">oficinas virtuales</span>
                            </h3>
                            <form onSubmit={handleSubmit} className="space-y-4">
                                <input 
                                    type="text" 
                                    name="nombre" 
                                    placeholder="Nombre*" 
                                    className="w-full px-4 py-2 border bg-[#F2EEEE]" 
                                    value={formData.nombre} 
                                    onChange={handleChange} 
                                    required 
                                />
                                <input 
                                    type="text" 
                                    name="apellido" 
                                    placeholder="Apellido*" 
                                    className="w-full px-4 py-2 border bg-[#F2EEEE]" 
                                    value={formData.apellido} 
                                    onChange={handleChange} 
                                    required 
                                />
                                <input 
                                    type="text" 
                                    name="empresa" 
                                    placeholder="Empresa*" 
                                    className="w-full px-4 py-2 border bg-[#F2EEEE]" 
                                    value={formData.empresa} 
                                    onChange={handleChange} 
                                />
                                <input 
                                    type="email" 
                                    name="email" 
                                    placeholder="Email*" 
                                    className="w-full px-4 py-2 border bg-[#F2EEEE]" 
                                    value={formData.email} 
                                    onChange={handleChange} 
                                    required 
                                />
                                <input 
                                    type="tel" 
                                    name="telefono" 
                                    placeholder="Teléfono móvil*" 
                                    className="w-full px-4 py-2 border bg-[#F2EEEE]" 
                                    value={formData.telefono} 
                                    onChange={handleChange} 
                                />
                                <input 
                                    type="text" 
                                    name="industria" 
                                    placeholder="Industria*" 
                                    className="w-full px-4 py-2 border bg-[#F2EEEE]" 
                                    value={formData.industria} 
                                    onChange={handleChange} 
                                />
                                <div className="flex justify-between">
                                    <button type="submit" className="w-[48%] bg-[#000] text-white border border-black transition-all duration-500 hover:bg-white hover:text-black font-medium px-4 py-2 md:mb-[10px]">Enviar</button>
                                </div>
                            </form>
                            {status && <p>{status}</p>}
                        </motion.div>
                        {acfData?.video &&
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                variants={{
                                    hidden: { opacity: 0, x: 200 },
                                    visible: { opacity: 1, x: 0 },
                                }}
                                transition={{ duration: 0.5 }}
                                className="w-1/2 flex-1 flex justify-center relative before:absolute before:bottom-[-2px] before:right-[-15px] before:w-[30px] before:bg-white before:h-[51%] after:content-[''] after:h-[30px] after:w-[30px] after:rotate-45 after:bg-white after:right-[-21px] after:top-[46%] after:absolute"
                            >
                                <video loop muted autoPlay playsInline className="rounded-[15px] w-full">
                                    <source src={video} type="video/mp4" />
                                    Tu navegador no soporta la etiqueta de video.
                                </video>
                            </motion.div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contacto;